var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('c-source-page',{attrs:{"table":_vm.table,"columns":_vm.columns,"pagination":_vm.pagination,"resource":"after_sales"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }